// extracted by mini-css-extract-plugin
module.exports = {"root":"FrontImage_root__1B3u3","title":"FrontImage_title__2im4O"};